import { render } from "./SleepModal.vue?vue&type=template&id=b6f8afd8&ts=true"
import script from "./SleepModal.vue?vue&type=script&lang=ts"
export * from "./SleepModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__